import { Component, Input, OnInit } from '@angular/core';
import { HintTypeEnum } from 'projects/workspace/src/app/hrm/models/hints-list.model';
import { takeUntil } from 'rxjs/operators';
import { getOutgoingInvoicesHints } from 'projects/workspace/src/app/outgoing-invoice/outgoing-invoices-hints.config';
import {
  BaseMegaHintComponentDependences,
  BaseMegaHintsComponent
} from '../../../rnpl-common/components/base-mega-hints/base-mega-hints.component';

@Component({
  selector: 'rnpl-position-modals-hints',
  templateUrl: './position-modals-hints.component.html',
  styleUrls: ['./position-modals-hints.component.css']
})
export class PositionModalsHintsComponent extends BaseMegaHintsComponent implements OnInit {
  @Input() public showDropdownHints: boolean;
  @Input() public screenName: string;
  constructor(
    public deps: BaseMegaHintComponentDependences
  ) {
    super(deps);
  }

  ngOnInit() {
    this.endFinishText = 'MEGA_HINT.END_STEP.CRATE_POSITIONS';
    if (this.shepherdService.isActive) {
      this.shepherdService.cancel();
    }

    this.initHints();
  }

  private initHints(): void {
    this.hintsList = [];
    this.notViewedHintsList = [];

    this.hrmService.getHintsByPage(this.screenName)
      .pipe(takeUntil(this._destroy))
      .subscribe(hints => {

        if (!!hints.data.hints && !!hints.data.hints.length) {
          this.hintListByName = getOutgoingInvoicesHints(
            null,
            false,
            false,
            false,
            this.showDropdownHints
          );

          this.hintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.notViewedHintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !hint.viewed)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.megaHintId = +hints.data.hints[0].id;

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.addHintsSteps(this.notViewedHintsList);
          }

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.shepherdService.start();
          }
        }
      });
  }
}
